export default __webpack_public_path__ + "static/media/generate-warning.b18f49ec.svg";